import { render, staticRenderFns } from "./TreatmentDatabase.vue?vue&type=template&id=d8cee54c&scoped=true&"
import script from "./TreatmentDatabase.vue?vue&type=script&lang=ts&"
export * from "./TreatmentDatabase.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentDatabase.vue?vue&type=style&index=0&id=d8cee54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cee54c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabs})
